import React, { useEffect, useMemo, useState } from "react";
import { Navigate } from "react-router-dom";

// Solo existe V2
import { LandingPage as LandingPageV2 } from "./LandingPage/LandingPage";

function getQueryParam(name) {
  // Query antes del hash:  /?force=landing#/
  const a = new URLSearchParams(window.location.search).get(name);
  if (a) return a;

  // Query dentro del hash (HashRouter): /#/?force=landing
  const hash = window.location.hash || "";
  const qIndex = hash.indexOf("?");
  if (qIndex !== -1) {
    const hashQuery = hash.substring(qIndex); // incluye '?'
    return new URLSearchParams(hashQuery).get(name);
  }

  return null;
}

export function PublicEntry() {
  const [isReady, setIsReady] = useState(false);
  const [shouldShowLanding, setShouldShowLanding] = useState(true);

  const forceLanding = useMemo(() => getQueryParam("force") === "landing", []);

  useEffect(() => {
    const userAgent = (navigator.userAgent || "").toLowerCase();

    // ✅ Solo bloqueamos VR
    const isVR = /oculus|quest|wolvic|pico|vive/i.test(userAgent);

    // Landing permitida para todo excepto VR (salvo que se fuerce)
    setShouldShowLanding(!isVR || forceLanding);
    setIsReady(true);
  }, [forceLanding]);

  if (!isReady) return null;

  if (shouldShowLanding) return <LandingPageV2 />;

  return <Navigate to="/auth" replace />;
}
